<template>
  <div>
    <v-row>
      <v-col class='flex justify-center'>
        <v-img
          lazy-src='@/assets/icons/svg/error-color.svg'
          src='@/assets/icons/svg/error-color.svg'
          max-width='100'
        />
      </v-col>
    </v-row>
    <v-row v-if='integrationInfo && integrationInfo.warehouse'>
      <v-col>
        <h6 class='font-weight-bold text-center'>
          Error! <br />
          Something went wrong and Synchronization was not completed. Please check your warehouse "<router-link :to='{ name: "EditWarehouse", params: { id: integrationInfo.warehouse.id } }'>{{ integrationInfo.warehouse.name }}</router-link>" and try again.
        </h6>
      </v-col>
    </v-row>
    <v-row>
      <v-col class='flex justify-center'>
        <v-btn
          color='#7972c0'
          depressed
          :to='{ name: "IntegrationAllSyncs" }'
        >
          <span class='text-white'>
            Go to Syncs List
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    warehouseId: 0
  }),
  computed: {
    ...mapGetters('integrations', {
      integrationInfo: 'getIntegrationInfo'
    })
  },
  created() {
    if (!this.integrationInfo.id) {
      this.$router.push({ name: 'IntegrationAllSyncs' })
    }
  }
}
</script>
